import { useState, useEffect } from 'react';

const useSearchApi = (history) => {
  const [results, setResults] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchResults = async () => {
      if (!history) return;

      setIsLoading(true);
      setError(null);

      try {
        let messagesAI = [{ role: "system", content: "" }];
        for (const message of history) {
          if (message.type === "user") {
            messagesAI.push({ role: "user", content: [{type: "text", text: message.text}] });
          } else {
            messagesAI.push({ role: "assistant", content: message.text });
          }
        }

        const body = {
          model: "gpt-4o",
          messages: messagesAI,
          stream: false, 
        };

        // 替换为你的实际 API 端点
        const response = await fetch(process.env.REACT_APP_AI_SEARCH_API_URL, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(body)
        });

        if (!response.ok) {
          throw new Error('Failed to fetch search results');
        }
        const data = await response.json();
        // console.log(data);
        setResults(data.choices[0].message.content);
      } catch (err) {
        setError(err.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchResults();
  }, [history]);

  return { results, isLoading, error };
};

export default useSearchApi;